import type { EstimateItemType } from '../types';

/**
 * Tipos de partida que se cobran a costo, sin margen ni markup.
 *
 * Permisos, tasas de tiradero y de laboratorio son cargos de un tercero que el
 * contratista remite a valor nominal. El propio corpus lo dice en la
 * descripción de sus partidas: "Permit & HOA fee allowance (pass-through, zero
 * margin)". Dividir un permiso de $400 entre (1 - 0,28) le cobra $555 al
 * cliente por un recibo de $400.
 *
 * Solo 'Fee'. 'Equipment' y 'Subcontractor' llevan riesgo real y se quedan en
 * el dial de margen; 'Material' tiene su propio dial de markup.
 *
 * VIVE AQUÍ, y no en cada sitio que cotiza, porque ya falló una vez por
 * duplicación: el soltado de plantilla exentaba los fees y `applyMargin` no,
 * así que un tirón del deslizador de margen deshacía el pase directo y devolvía
 * el markup. Una regla, un sitio.
 */
export function isPassThroughType(type: EstimateItemType | undefined): boolean {
    return type === 'Fee';
}

/** Los campos de precio de una fila de pase directo. */
export function passThroughPricing(cost: number, quantity: number) {
    return {
        rate: cost,
        total: cost * quantity,
        markupPercent: 0,
        marginPercent: 0,
    };
}
